import { UI } from '../../modules/UI';

export const notFound = (function () {
  let page = () => {
    let template = require(`./tmpl/404.hbs`);
    UI.pagewrap(template);
  };

  return {
    page
  };
})();
